export const TRANSIT_MAP_PHASES = {
  SETTLING: "settling",
  AT_STATION: "at-station",
  IN_TRANSIT: "in-transit",
  DECISION: "decision",
  BRANCH_TRAVEL: "branch-travel",
  UNDERWRITING_REVIEW: "underwriting-review",
  FINALIZE_YES: "finalize-yes",
  COMPLETE: "complete",
};

export const TRANSIT_MAP_TIMING = {
  settle: 1200,
  travel: 1600,
  stations: [2100, 2200, 2500, 2200, 2600, 3200],
  decision: 1800,
  branchTravel: 2200,
  underwritingReview: 3200,
  finalizeYes: 1800,
};

export const TRANSIT_MAP_INITIAL_STATE = {
  phase: TRANSIT_MAP_PHASES.SETTLING,
  stationIndex: 0,
  elapsedMs: 0,
  playing: true,
  journeyId: 0,
};

export function getTransitMapDuration(state) {
  if (state.phase === TRANSIT_MAP_PHASES.SETTLING) {
    return TRANSIT_MAP_TIMING.settle;
  }
  if (state.phase === TRANSIT_MAP_PHASES.IN_TRANSIT) {
    return TRANSIT_MAP_TIMING.travel;
  }
  if (state.phase === TRANSIT_MAP_PHASES.DECISION) {
    return TRANSIT_MAP_TIMING.decision;
  }
  if (state.phase === TRANSIT_MAP_PHASES.BRANCH_TRAVEL) {
    return TRANSIT_MAP_TIMING.branchTravel;
  }
  if (state.phase === TRANSIT_MAP_PHASES.UNDERWRITING_REVIEW) {
    return TRANSIT_MAP_TIMING.underwritingReview;
  }
  if (state.phase === TRANSIT_MAP_PHASES.FINALIZE_YES) {
    return TRANSIT_MAP_TIMING.finalizeYes;
  }
  return (
    TRANSIT_MAP_TIMING.stations[state.stationIndex] ??
    TRANSIT_MAP_TIMING.stations[0]
  );
}

function advanceTransitMap(state, lastStationIndex) {
  if (state.phase === TRANSIT_MAP_PHASES.SETTLING) {
    return {
      ...state,
      phase: TRANSIT_MAP_PHASES.AT_STATION,
      elapsedMs: 0,
    };
  }

  if (state.phase === TRANSIT_MAP_PHASES.AT_STATION) {
    if (state.stationIndex === lastStationIndex - 1) {
      return {
        ...state,
        phase: TRANSIT_MAP_PHASES.DECISION,
        elapsedMs: 0,
      };
    }
    return {
      ...state,
      phase: TRANSIT_MAP_PHASES.IN_TRANSIT,
      elapsedMs: 0,
    };
  }

  if (state.phase === TRANSIT_MAP_PHASES.IN_TRANSIT) {
    return {
      ...state,
      phase: TRANSIT_MAP_PHASES.AT_STATION,
      stationIndex: Math.min(lastStationIndex, state.stationIndex + 1),
      elapsedMs: 0,
    };
  }

  if (state.phase === TRANSIT_MAP_PHASES.DECISION) {
    return {
      ...state,
      phase: TRANSIT_MAP_PHASES.BRANCH_TRAVEL,
      elapsedMs: 0,
    };
  }

  if (state.phase === TRANSIT_MAP_PHASES.BRANCH_TRAVEL) {
    return {
      ...state,
      phase: TRANSIT_MAP_PHASES.UNDERWRITING_REVIEW,
      stationIndex: lastStationIndex,
      elapsedMs: 0,
    };
  }

  if (state.phase === TRANSIT_MAP_PHASES.UNDERWRITING_REVIEW) {
    return {
      ...state,
      phase: TRANSIT_MAP_PHASES.FINALIZE_YES,
      elapsedMs: 0,
    };
  }

  if (state.phase === TRANSIT_MAP_PHASES.FINALIZE_YES) {
    return {
      ...state,
      phase: TRANSIT_MAP_PHASES.COMPLETE,
      elapsedMs: 0,
      playing: false,
    };
  }

  return state;
}

export function transitMapReducer(state, action) {
  switch (action.type) {
    case "TICK": {
      if (!state.playing || state.phase === TRANSIT_MAP_PHASES.COMPLETE) {
        return state;
      }

      const duration = getTransitMapDuration(state);
      const elapsedMs = state.elapsedMs + Math.max(0, action.deltaMs || 0);
      if (elapsedMs < duration) {
        return { ...state, elapsedMs };
      }

      return advanceTransitMap(
        { ...state, elapsedMs: elapsedMs - duration },
        action.lastStationIndex,
      );
    }
    case "PAUSE":
      return state.phase === TRANSIT_MAP_PHASES.COMPLETE
        ? state
        : { ...state, playing: false };
    case "RESUME":
      return state.phase === TRANSIT_MAP_PHASES.COMPLETE
        ? state
        : { ...state, playing: true };
    case "REPLAY":
      return {
        ...TRANSIT_MAP_INITIAL_STATE,
        journeyId: state.journeyId + 1,
      };
    default:
      return state;
  }
}

export function getTransitMapProgress(state) {
  if (state.phase === TRANSIT_MAP_PHASES.COMPLETE) {
    return 1;
  }
  return Math.max(
    0,
    Math.min(1, state.elapsedMs / getTransitMapDuration(state)),
  );
}

export function easeTransitMap(progress) {
  const value = Math.max(0, Math.min(1, progress));
  return value * value * (3 - 2 * value);
}
